import { render, staticRenderFns } from "./RankingCardParts.vue?vue&type=template&id=3055ca49&scoped=true"
import script from "./RankingCardParts.vue?vue&type=script&lang=ts"
export * from "./RankingCardParts.vue?vue&type=script&lang=ts"
import style0 from "./RankingCardParts.vue?vue&type=style&index=0&id=3055ca49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055ca49",
  null
  
)

export default component.exports